module.exports = "<tree-diagram [data]=\"tree\"></tree-diagram>\n\n             "


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-tree-diagram/app-tree-diagram.component.html
// module id = ./src/app/components/app-tree-diagram/app-tree-diagram.component.html
// module chunks = main